import React from "react";

const ArrowDownIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <defs>
        <clipPath id="clipPath3445599397">
          <path
            d="M0 0L24 0L24 24L0 24L0 0Z"
            fillRule="nonzero"
            transform="matrix(1 0 0 1 0 0)"
          />
        </clipPath>
      </defs>
      <g clipPath="url(#clipPath3445599397)">
        <path
          d="M-0.707107 -0.707107C-1.09763 -0.316586 -1.09763 0.316586 -0.707107 0.707107L5.29289 6.70711Q5.43355 6.84776 5.61732 6.92388Q5.80109 7 6 7Q6.19891 7 6.38268 6.92388Q6.56645 6.84776 6.70711 6.70711L12.7071 0.707107C13.0976 0.316586 13.0976 -0.316586 12.7071 -0.707107C12.3166 -1.09763 11.6834 -1.09763 11.2929 -0.707107L6 4.58579L0.707107 -0.707107C0.316586 -1.09763 -0.316586 -1.09763 -0.707107 -0.707107Z"
          fillRule="evenodd"
          transform="matrix(1 0 0 1 6 9)"
          fill="rgb(255, 255, 255)"
        />
      </g>
    </svg>
  );
};

export default ArrowDownIcon;
